import { Pipe, PipeTransform } from '@angular/core';
import { ListType } from '@wdx/clmi/clmi-swagger-gen';
import { LIST_TYPE_MAP } from '../constants/list-types.constants';

@Pipe({ name: 'listType', standalone: false })
export class ListTypePipe implements PipeTransform {
    transform(listType: ListType | null | undefined): string {
        if (!listType?.code) {
            return '';
        }
        return LIST_TYPE_MAP[listType.code];
    }
}
